import { render, staticRenderFns } from "./EditarDatos.vue?vue&type=template&id=2616ea06"
import script from "./EditarDatos.vue?vue&type=script&lang=js"
export * from "./EditarDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports